<template>
    <div class="student-page my-credit">
        我的学分
        <!-- <el-row :gutter="20">
            <el-col :span="16">
                <div class="rank-chart">
                    <div class="credit-pie">
                        <p class="s-box-name">学分分布</p>
                        <div v-show="creditPieShow" id="creditPie" class="figure"></div>
                        <p v-show="!creditPieShow" class="emptyBox"><i
                            class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                    </div>
                    <div class="credit-bar">
                        <p class="s-box-name">学分统计</p>
                        <div v-show="creditBarShow" id="creditBar" class="figure"></div>
                        <p v-show="!creditBarShow" class="emptyBox"><i
                            class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}</p>
                    </div>

                </div>

            </el-col>
            <el-col :span="8">
                <div class="rank-panel">

                    <div class="rank-top">

                        <div class="rank-name">
                            <p class="rank">排行榜</p>
                            <p class="rank-tip">( 排行榜可能略有延迟~ )</p>
                            <div class="drop-date">
                                <el-select v-model="rankType" size="small" @change="selectRankType">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>

                        </div>

                        <div class="user-rank">
                            <div class="user-credit">
                                <p class="rank-title">积分</p>
                                <p class="rank-value">
                                    {{currentUser.point}}
                                </p>
                            </div>
                            <div class="user-avatar">
                                <img class="avatar" v-if="userInfo.avatar" :src="userInfo.avatar" alt="">
                                <img class="avatar" v-else src="../../assets/images/common/default_avatar.jpg" alt="">
                                <p class="user-name">{{userInfo.userName}}</p>
                            </div>
                            <div class="user-credit">
                                <p class="rank-title">排名</p>
                                <p class="rank-value">
                                    <span v-if="currentUser.rank==0" style="font-size: 16px">未上榜</span>
                                    <span v-else>{{currentUser.rank}}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="rank-bottom" v-if="creditsList.length>0">

                        <ul class="record-list">
                            <li class="record-list-item" v-for="(item,index) in creditsList" :key="'r'+item.rank">
                                <p class="item-index">{{item.rank}}</p>
                                <img class="avatar" v-if="item.avatar" :src="item.avatar" alt="">
                                <img class="avatar" v-else src="../../assets/images/common/default_avatar.jpg" alt="">
                                <p class="item-name">{{item.userName}}</p>
                                <p class="point">{{item.point}}</p>
                            </li>
                        </ul>

                    </div>
                    <p class="no-rank-list" v-else>暂无排名</p>
                </div>


            </el-col>
        </el-row> -->



    </div>
</template>
<script>
import api from '@/api';
var echarts = require('echarts');
export default {
    data(){
        return {
            userInfo: {},
            creditsList: [
                {rank: 1, userName: '肖邦', point: 300, avatar: ''},
                {rank: 2, userName: '贝多芬', point: 200, avatar: ''},
                {rank: 3, userName: '巴尔扎克', point: 100, avatar: ''},
                {rank: 4, userName: '柴可夫斯基', point: 50, avatar: ''},
            ],
            rankType: '1',
            options: [ {value: '1',label: '月榜'},
                {value: '3', label: '季榜'},
                {value: '5', label: '年榜'},
                {value: '0', label: '全部'},],
            currentUser:{
                point: 0,
                rank: 0
            },
            pieData: [
                {id: "1", name: "课件", value: 17},
                {id: "2", name: "考卷", value: 25},
                {id: "3", name: "模拟练习", value: 8},
            ]

        }
    },
    created() {
        // this.getCreditType();
    },
    methods:{
        getCreditType(){
            let creditTypeChart = echarts.init(document.getElementById("creditPie"));
            //制定图标的配置项和数据
            creditTypeChart.showLoading();
            api.getCourseStatistics().then(res => {
                let data = res.package;
                if (data) {
                    let num = 0;
                    let legendData = [];
                    let seriesData = [];
                    data.forEach(value => {
                        legendData.push(value.name);
                        seriesData.push({'name': value.name, 'value': value.value})
                        num += value.value;
                    });
                    if (num > 0) {
                        // this.taskFinishShow = true;
                        let option = {
                            color: ['#2e7faa', ' #f4516c', '#ffb822'],
                            tooltip: {
                                trigger: 'item',
                                formatter: "{a} <br/>{b} : {c} ({d}%)"
                            },
                            legend: {
                                orient: 'vertical',
                                x: 'right',
                                data: legendData,
                            },
                            series: [
                                {
                                    name: this.$t('count.quantity'),
                                    type: 'pie',
                                    radius: ['50%', '70%'],
                                    avoidLabelOverlap: false,
                                    label: {
                                        normal: {
                                            show: false,
                                            position: 'center'
                                        },
                                        emphasis: {
                                            show: true,
                                            textStyle: {
                                                fontSize: '30',
                                                fontWeight: 'bold'
                                            }
                                        }
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    data: seriesData,
                                },
                            ]
                        };
                        creditTypeChart.hideLoading();
                        creditTypeChart.setOption(option);
                        window.addEventListener('resize', function () {
                            creditTypeChart.resize();
                        })
                    } else {
                        creditTypeChart.hideLoading();
                        this.creditPieShow = false;
                    }
                } else {
                    creditTypeChart.hideLoading();
                    this.creditPieShow = false;
                }

            })

        }

    }
}
</script>
<style scoped lang="scss">
    @import '../../style/const';
    $fontColor:#666;
    .student-page {
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .rank-panel{
        width: 100%;
        height: 100%;
        box-shadow: 0 1px 5px #c5d0dd;

        .rank-top{
            width: 100%;
            height: 30%;
            .rank-name{
                width: 100%;
                height: 140px;
                font-size: 16px;
                text-align: center;
                padding-top: 20px;
                margin-bottom: 20px;
                font-size: 20px;
                color: #fff;
                background-color: #ffb822;
                border-bottom-left-radius: 50px;
                border-bottom-right-radius: 50px;
                .rank-tip{
                    font-size: 11px;
                    /*color: rgba(0, 0, 0, .5);*/
                    margin-top: 3px;
                }

            }
            .drop-date{
                margin-top: -30px;
                text-align: right;
                margin-right: 10px;
            }
            .user-rank{
                display: flex;
                width: 80%;
                height: 140px;
                margin-top:-90px;
                margin-bottom: 10px;
                margin-left: 10%;
                background-color: #fff;
                border-radius: 5px;
                box-shadow: 0 1px 5px #c5d0dd;
                padding: 20px;
                justify-content: space-around;
                align-items: center;
                .user-credit{
                    text-align: center;
                    .rank-title{
                        font-size: 16px;
                        color: $fontColor;
                        margin-bottom: 15px;
                    }
                    .rank-value{
                        font-size: 20px;
                        color: #ffb822;
                    }
                }
                .user-avatar{
                    text-align: center;
                    .avatar{
                        height: 60px;
                        width: 60px;
                        border-radius: 50%;
                        margin-bottom: 10px;
                    }
                    .user-name{
                        color: $fontColor;
                    }
                }

            }
        }

        .rank-bottom{
            height: 70%;
            padding-left: 20px;
            .record-list{
                height: 100%;
                overflow-y: auto;
            }
            .record-list-item {

                position: relative;
                display: flex;
                padding: 10px 24px 10px 55px;
                background-color: #fff;
                border-bottom: 1px solid #eee;


                .item-index {
                    position: absolute;
                    top: 50%;
                    left: 20px;
                    transform: translateY(-50%);
                    font-size: 20px;
                    color: $fontColor;
                }



                .avatar {
                    height: 54px;
                    width: 54px;
                    border-radius: 50%;
                }

                .item-name {
                    flex: 1;
                    line-height: 60px;
                    color: $fontColor;
                    padding-left: 15px;
                }

                .point {
                    flex: 1;
                    line-height: 60px;
                    font-size: 20px;
                    color: #ffb822;
                    text-align: right;
                }

                &.my-rank {
                    width: 94%;
                    height:20px;
                    margin: 0 auto;
                    border-radius: 10px 10px 0 0;
                    background-color: #fff;
                    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, .2);

                }

                &.my-rank-null {
                    height: 20px;
                }
            }

        }
        .no-rank-list{
            margin-top: 180px;
            text-align: center;
            color: $fontColor;
        }
    }

</style>